export const environment = {
  production: true,
  url: 'https://api.analise.people.private.unico.run',
  base_url: 'https://temporary.analise.acessorh.com.br',
  identity_url: 'https://identity.acesso.io',
  cookie_url: 'https://admin.people.unico.app/svc2/authorize',
  people_url: 'https://admin.people.unico.app/svc2'
};
